import { atom } from 'jotai';

import { AdminFeeMessages } from './AdminFee.messages';

export const adminFeeMessagesAtom = atom<AdminFeeMessages | null>(null);
